module.exports = __webpack_public_path__ + "static/fonts/roboto-medium-webfont.d8ab400.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto-medium-webfont.woff2
// module id = 1665
// module chunks = 28